(function () {
  const templateId = 'sj-mobile-menu-template';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let attempts = 0;
  let applied = false;

  function findOriginalMenu() {
    const candidates = document.querySelectorAll(
      '.header__drawer .menu-drawer__menu, .menu-drawer__navigation .menu-drawer__menu, .menu-drawer .menu-drawer__menu'
    );

    return Array.from(candidates).find((menu) => {
      return !menu.classList.contains('sj-mobile-menu') && !menu.closest('.sj-mobile-menu');
    });
  }

  function patchMobileMenu() {
    if (applied || !mobileQuery.matches) return;

    const template = document.getElementById(templateId);
    if (!template || !template.content || !template.content.firstElementChild) return;

    const alreadyApplied = document.querySelector('.header__drawer .sj-mobile-menu, .menu-drawer .sj-mobile-menu');
    if (alreadyApplied) {
      applied = true;
      return;
    }

    const originalMenu = findOriginalMenu();
    if (!originalMenu) return;

    originalMenu.replaceWith(template.content.firstElementChild.cloneNode(true));
    applied = true;
  }

  function schedulePatch() {
    window.setTimeout(patchMobileMenu, 80);
  }

  function retryPatch() {
    patchMobileMenu();
    attempts += 1;
    if (!applied && attempts < 8) {
      window.setTimeout(retryPatch, 180);
    }
  }

  document.addEventListener('DOMContentLoaded', retryPatch);
  document.addEventListener('click', schedulePatch, true);
  window.addEventListener('resize', function () {
    if (!mobileQuery.matches) return;
    applied = false;
    attempts = 0;
    schedulePatch();
  });

  retryPatch();
})();

(function () {
  const groupHeadings = {
    'découvrir le salon': 'DÉCOUVRIR LE SALON',
    'services & tarifs': 'SERVICES & TARIFS',
    'expertises coiffure': 'EXPERTISES COIFFURE',
    'par type de cheveux': 'PAR TYPE DE CHEVEUX',
    'par préoccupation': 'PAR PRÉOCCUPATION',
    'cheveux colorés & éclaircis': 'CHEVEUX COLORÉS & ÉCLAIRCIS',
    'les services en salon': 'LES SERVICES EN SALON'
  };
  const styleId = 'sj-menu-group-heading-style';
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  let attempts = 0;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getHeadingLabel(value) {
    return groupHeadings[normalizeText(value)] || null;
  }

  function injectHeadingStyles() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #header-component [data-sj-menu-group-heading="true"],
      #header-component [data-sj-menu-group-heading="true"] *,
      .shopify-section-header [data-sj-menu-group-heading="true"],
      .shopify-section-header [data-sj-menu-group-heading="true"] * {
        display: block !important;
        width: max-content !important;
        max-width: 100% !important;
        margin: 0 0 20px !important;
        padding: 0 !important;
        font-family: Inter, "Helvetica Neue", Arial, sans-serif !important;
        font-size: 11.5px !important;
        font-weight: 900 !important;
        font-synthesis: weight !important;
        font-variation-settings: "wght" 900 !important;
        line-height: 1.15 !important;
        letter-spacing: 0.105em !important;
        text-transform: uppercase !important;
        color: #000000 !important;
        opacity: 1 !important;
        text-decoration: none !important;
        pointer-events: none !important;
        cursor: default !important;
      }
    `;
    document.head.appendChild(style);
  }

  function forceHeadingStyles(target) {
    if (!target || !target.style) return;

    target.style.setProperty('font-family', 'Inter, "Helvetica Neue", Arial, sans-serif', 'important');
    target.style.setProperty('font-size', '11.5px', 'important');
    target.style.setProperty('font-weight', '900', 'important');
    target.style.setProperty('font-synthesis', 'weight', 'important');
    target.style.setProperty('font-variation-settings', '"wght" 900', 'important');
    target.style.setProperty('line-height', '1.15', 'important');
    target.style.setProperty('letter-spacing', '0.105em', 'important');
    target.style.setProperty('text-transform', 'uppercase', 'important');
    target.style.setProperty('color', '#000000', 'important');
    target.style.setProperty('opacity', '1', 'important');
    target.style.setProperty('text-decoration', 'none', 'important');
    target.style.setProperty('pointer-events', 'none', 'important');
    target.style.setProperty('cursor', 'default', 'important');
  }

  function patchDesktopGroupHeadings() {
    if (!desktopQuery.matches) return;

    const header = document.querySelector('#header-component, .shopify-section-header, header');
    if (!header) return;

    injectHeadingStyles();

    const candidates = header.querySelectorAll('a, button, summary, span');
    candidates.forEach(function (candidate) {
      const label = getHeadingLabel(candidate.textContent);
      if (!label) return;

      const target = candidate.matches('a, button, summary')
        ? candidate
        : candidate.closest('a, button, summary') || candidate;

      target.dataset.sjMenuGroupHeading = 'true';
      target.setAttribute('aria-disabled', 'true');
      target.setAttribute('tabindex', '-1');
      target.textContent = label;
      forceHeadingStyles(target);

      const href = target.getAttribute('href');
      if (href === '#') target.setAttribute('role', 'presentation');
    });
  }

  function retryPatch() {
    patchDesktopGroupHeadings();
    attempts += 1;
    if (attempts < 8) {
      window.setTimeout(retryPatch, 180);
    }
  }

  function blockNavigation(event) {
    const target = event.target && event.target.closest
      ? event.target.closest('[data-sj-menu-group-heading="true"]')
      : null;

    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
  }

  document.addEventListener('DOMContentLoaded', retryPatch);
  document.addEventListener('mouseenter', patchDesktopGroupHeadings, true);
  document.addEventListener('focusin', patchDesktopGroupHeadings, true);
  document.addEventListener('click', blockNavigation, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    blockNavigation(event);
  }, true);
  document.addEventListener('shopify:section:load', patchDesktopGroupHeadings);

  retryPatch();
})();
